import { render, staticRenderFns } from "./GameBoard.vue?vue&type=template&id=a53030d6&scoped=true&"
import script from "./GameBoard.vue?vue&type=script&lang=ts&"
export * from "./GameBoard.vue?vue&type=script&lang=ts&"
import style0 from "./GameBoard.vue?vue&type=style&index=0&id=a53030d6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a53030d6",
  null
  
)

component.options.__file = "GameBoard.vue"
export default component.exports